/*
 * mobile-menu-enhance.js
 *
 * The mobile menu is a CSS accordion: a visually hidden checkbox per level,
 * toggled by its label. That keeps it working without JS. This file adds the
 * parts CSS alone cannot do:
 *
 *   - measured open/close heights, so every section animates at the same speed
 *     instead of snapping open (the theme used `max-height: none` when checked)
 *   - one section open at a time per level
 *   - the opened section scrolled into view when it would otherwise be offscreen
 *   - aria-expanded / aria-controls on the toggles for screen readers
 *
 * Paired with the ".mobile-menu" block at the end of custom-styles.css.
 */
(function () {
  'use strict';

  var MENU = '.mobile-menu';
  var SUBMENU = '.mobile-menu__submenu';
  var uid = 0;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }
 
  function submenuOf(input) {
    var el = input.nextElementSibling;
    while (el && !el.matches(SUBMENU)) el = el.nextElementSibling;
    return el;
  }

  function openSubmenus(root) {
    return toArray(root.querySelectorAll('.submenu__input:checked'))
      .map(submenuOf)
      .filter(Boolean);
  }

  // Measure with the clamp lifted, so nested open levels report their real
  // height, then write the targets back and let the transition run.
  function measure(root) {
    var html = document.documentElement;
    var open = openSubmenus(root);

    html.classList.add('js-mm-measuring');
    var heights = open.map(function (ul) {
      return ul.scrollHeight;
    });
    html.classList.remove('js-mm-measuring');

    open.forEach(function (ul, i) {
      ul.style.setProperty('--mm-submenu-height', heights[i] + 'px');
    });
  }

  // One open section per level: close the other branches beside this one.
  function collapseSiblings(input) {
    var item = input.closest('li');
    if (!item || !item.parentElement) return;

    toArray(item.parentElement.children).forEach(function (sibling) {
      if (sibling === item) return;
      toArray(sibling.querySelectorAll('.submenu__input:checked')).forEach(function (other) {
        other.checked = false;
        syncAria(other);
      });
    });
  }

  function syncAria(input) {
    var label = input.nextElementSibling;
    if (!label || label.tagName !== 'LABEL') return;
    label.setAttribute('aria-expanded', input.checked ? 'true' : 'false');
  }

  function revealIfNeeded(input) {
    var label = input.nextElementSibling;
    var menu = input.closest(MENU);
    if (!label || !menu || !input.checked) return;

    window.setTimeout(function () {
      var row = label.getBoundingClientRect();
      var frame = menu.getBoundingClientRect();
      if (row.top >= frame.top && row.bottom <= frame.bottom) return;
      menu.scrollTop += row.top - frame.top - 8;
    }, 340);
  }

  function onToggle(event) {
    var input = event.target;
    if (!input.matches || !input.matches('.submenu__input')) return;

    var menu = input.closest(MENU);
    if (!menu) return;

    if (input.checked) collapseSiblings(input);
    syncAria(input);
    measure(menu);
    revealIfNeeded(input);
  }

  function annotate(menu) {
    toArray(menu.querySelectorAll('.submenu__input')).forEach(function (input) {
      var label = input.nextElementSibling;
      var submenu = submenuOf(input);
      if (!label || label.tagName !== 'LABEL' || !submenu) return;

      if (!submenu.id) submenu.id = 'mobile-submenu-panel-' + ++uid;
      label.setAttribute('aria-controls', submenu.id);
      syncAria(input);
    });
  }

  function init() {
    var menu = document.querySelector(MENU);
    if (!menu || menu.dataset.mmEnhanced === 'true') return;
    menu.dataset.mmEnhanced = 'true';

    annotate(menu);

    measure(menu);

    menu.addEventListener('change', onToggle);

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        measure(menu);
      }, 150);
    });
  }

  function reinit() {
    var menu = document.querySelector(MENU);
    if (menu) delete menu.dataset.mmEnhanced;
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The header section re-renders in the theme editor.
  document.addEventListener('shopify:section:load', reinit);
})();
